interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) pages.push(i);
    else if (pages[pages.length - 1] !== -1) pages.push(-1);
  }

  const baseClass =
    "min-w-10 h-10 px-3 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="mt-10 flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className={`${baseClass} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:pointer-events-none`}
      >
        <i className="ri-arrow-left-s-line text-base mr-1"></i>
        上一页
      </button>

      {pages.map((item, index) =>
        item === -1 ? (
          <span key={`gap-${index}`} className="px-1 text-foreground-400">
            ···
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`${baseClass} ${
              item === page
                ? "bg-primary-500 text-background-50 font-medium"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className={`${baseClass} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:pointer-events-none`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-base ml-1"></i>
      </button>
    </nav>
  );
}